import { FC, useEffect, useState } from 'react'
import { TableHelperButtons } from '../../../components/buttons/TableHelperButtons'
import ScheduleApi from '../../../../infrastructure/api/ScheduleApi'
import { IPaginationFilter } from '../../../../models/requests/PaginationFilter'
import { GenericTable } from '../../../components/tables/GenericTable'
import { PagedResponseModel } from '../../../../models/responses/PagedResponseModel'
import { ITrainerCommentModel } from '../../../../models/responses/ScheduleModel'
import { Link } from 'react-router-dom'
import { TableHelperButtonEnum } from '../../../enums/TableHelperButtonEnum'
import parse from 'html-react-parser'
import { IStudentsModel } from '../../../../models/responses/StudentModel'
type Props = {
    onClickItem: (itemId: any, itemName: string, type: string) => void
    refresh: number
}

const TrainerCommentListModal: FC<Props> = ({ onClickItem, refresh }) => {
    const [pageNumber, setPageNumber] = useState(1)
    const [pageSize, setPageSize] = useState(10)
    const [searchText, setSearchText] = useState('')
    const [sort, setSort] = useState('title_asc')
    const [trainerComments, setTrainerComments] = useState<PagedResponseModel<ITrainerCommentModel[]>>()

    async function init() {
        const paginationFilter: IPaginationFilter = {
            page: pageNumber,
            size: pageSize,
            orderBy: sort,
            search: searchText,
        }

        var response = await ScheduleApi.GetTrainerComments(paginationFilter)
        setTrainerComments(response.data)
    }

    useEffect(() => {
        init()
    }, [refresh, pageNumber, pageSize, searchText, sort])

    return (
        <>
            <GenericTable
                title='Trainer Comments'
                data={trainerComments?.items}
                currentTotalRecords={trainerComments?.totalRecords!!}
                currentPageNumber={trainerComments?.pageNumber!!}
                columns={[
                    {
                        label: '#',
                        name: '#',
                        options: {
                            customBodyRenderLite: (dataIndex) => {
                                return <>{(pageNumber - 1) * pageSize + ++dataIndex}</>
                            },
                            sort: false,
                            viewColumns: false,
                            filter: false
                        },
                    },
                    {
                        label: "Student", name: "students", options: {
                            customBodyRender: (value) => {
                                return <b>{
                                    value.map((item: IStudentsModel) => {
                                        return (
                                            <b><Link to={'/account/users/' + item.id + '/overview'}>{item?.firstName} {item?.lastName}</Link></b>
                                        )
                                    })
                                }</b>
                            }
                        }
                    },
                    {
                        label: "Message", name: "message", options: {
                            customBodyRender: (value) => {
                                return <>{parse(value)}</>
                            }
                        }
                    },
                    {
                        label: "Auto Comment", name: "isAutoComment", options: {
                            customBodyRender: (value) => {
                                return <>{value ? <i className='fa fa-check'></i> : <></>}</>
                            }
                        }
                    },
                    {
                        label: "For Whom", name: "isForStudent", options: {
                            customBodyRender: (value) => {
                                return <>{value ? <span className='badge badge-light-primary'>Student</span> : <span className='badge badge-light-dark'>Other</span>}</>
                            }
                        }
                    },
                    {
                        label: "Trainer", name: "trainerFullName", options: {
                            customBodyRenderLite: (dataIndex) => {
                                return <b><Link to={'/account/users/' + trainerComments?.items[dataIndex]?.trainerId + '/overview'}>{trainerComments?.items[dataIndex]?.trainerFullName}</Link></b>
                            },
                        }
                    },
                    {
                        label: "Date", name: "date", options: {
                            customBodyRender: (value) => {
                                return <>{value}</>
                            }
                        }
                    },
                    {
                        label: '#',
                        name: 'Id',
                        options: {
                            customHeadLabelRender: (options) => {
                                return (
                                    <div className='d-flex justify-content-end flex-shrink-0'>{options.label}</div>
                                )
                            },
                            customBodyRenderLite: (dataIndex) => {
                                return (
                                    <TableHelperButtons
                                        itemId={trainerComments?.items[dataIndex]?.scheduleId!!}
                                        itemParam={trainerComments?.items[dataIndex]?.date}
                                        types={[TableHelperButtonEnum.View]}
                                        onClickItem={onClickItem}
                                    />
                                )
                            },
                            filter: false,
                            sort: false,
                            viewColumns: false,
                        },
                    },
                ]}
                customOptions={{
                    rowsPerPage: pageSize,
                    sort: false,
                    search: false,
                    customTableBodyFooterRender: (opts) => {
                        return <div></div>
                    },
                }}
                setPageNumber={setPageNumber}
                setPageSize={setPageSize}
                setSearchText={setSearchText}
                setSort={setSort}
            />
        </>
    )
}

export { TrainerCommentListModal }
